export const defaultWidgetsState = {
	proximity: {
		autoExpand: true
	},
	pinnedItems: {
		autoExpand: true
	},
	files: {
		defaultImageView: "slideshow"
	},
	layoutControls: {
		autoExpand: false
	},
	linkedItems: {
		autoExpand: true
	},
	list: {
		autoExpand: true
	},
	detailsWidget: {
		autoExpand: true
	}
};
